import { useTranslation } from 'react-i18next';

export default function CompareTable() {
  const { t } = useTranslation('home');
  const compareData = t('compare.rows', { returnObjects: true }) as Array<{
    id: string;
    category: string;
    model: string;
    tags: string[];
    range: string;
    price: string;
  }>;

  return (
    <section id="compare" className="py-10 md:py-14 bg-white">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-6">
            <div className="text-xs font-medium text-slate-400 uppercase tracking-wider mb-2">{t('compare.subtitle')}</div>
            <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-slate-900">
              {t('compare.title')}
            </h2>
          </div>

          <div className="overflow-x-auto -mx-4 px-4">
            <table className="w-full min-w-[720px] text-sm border border-slate-200 rounded-lg overflow-hidden">
              <thead>
                <tr className="bg-slate-50 text-left">
                  <th className="px-3 py-2.5 text-xs font-medium text-slate-500 border-b border-slate-200 whitespace-nowrap">{t('compare.col.id')}</th>
                  <th className="px-3 py-2.5 text-xs font-medium text-slate-500 border-b border-slate-200 whitespace-nowrap">{t('compare.col.category')}</th>
                  <th className="px-3 py-2.5 text-xs font-medium text-slate-500 border-b border-slate-200 whitespace-nowrap">{t('compare.col.model')}</th>
                  <th className="px-3 py-2.5 text-xs font-medium text-slate-500 border-b border-slate-200 whitespace-nowrap">{t('compare.col.params')}</th>
                  <th className="px-3 py-2.5 text-xs font-medium text-slate-500 border-b border-slate-200 whitespace-nowrap">{t('compare.col.range')}</th>
                  <th className="px-3 py-2.5 text-xs font-medium text-slate-500 border-b border-slate-200 whitespace-nowrap text-right">{t('compare.col.price')}</th>
                </tr>
              </thead>
              <tbody>
                {compareData.map((row, idx) => (
                  <tr
                    key={row.id}
                    className={`${idx % 2 === 0 ? 'bg-white' : 'bg-slate-50/50'} hover:bg-brand-50 transition-colors`}
                  >
                    <td className="px-3 py-3 text-xs text-slate-600 border-b border-slate-100 whitespace-nowrap">{row.id}</td>
                    <td className="px-3 py-3 text-xs text-slate-600 border-b border-slate-100 whitespace-nowrap">{row.category}</td>
                    <td className="px-3 py-3 text-xs font-semibold text-slate-900 border-b border-slate-100 whitespace-nowrap">{row.model}</td>
                    <td className="px-3 py-3 border-b border-slate-100">
                      <div className="flex flex-wrap gap-1">
                        {row.tags.map((tag) => (
                          <span
                            key={tag}
                            className="text-[10px] bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded whitespace-nowrap"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </td>
                    <td className="px-3 py-3 text-xs text-slate-500 border-b border-slate-100">{row.range}</td>
                    <td className="px-3 py-3 text-xs font-bold text-orange-600 border-b border-slate-100 text-right whitespace-nowrap">{row.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}